import { OrdersConstants } from './Orders.constants';
import moment from 'moment';
const initialState = {
  dateRange: [
    moment(moment().subtract(14, 'days'), 'DD/MM/YYYY').startOf('day'),
    moment(moment(), 'DD/MM/YYYY').endOf('day')
  ],
  pageNumber: 1,
  pageSize: 50,
  selectedTab: {},
  appliedFilters: {},
  selectedStore: [],
  appliedTags: [],
  orderFacets: {
    loading: false,
    error: false,
    data: {}
  },
  orderSLAFacets: {
    loading: false,
    error: false,
    data: {}
  }
};

const orderAppliedFilters = (state = initialState.appliedFilters, action) => {
  return { ...state, [action.filterType]: action.payload };
};

const OrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case OrdersConstants.APPLIED_FILTERS_ORDERS:
      const appliedFilters = orderAppliedFilters(state.appliedFilters, action);
      if (action.payload === '') delete appliedFilters[action.filterType];
      return {
        ...state,
        appliedFilters,
        pageNumber: initialState?.pageNumber
      };
    case OrdersConstants.APPLIED_TAGS_ORDERS:
      return {
        ...state,
        appliedTags: action.payload
      };

    case OrdersConstants.APPLIED_MULTIPLE_FILTERS_ORDERS:
      if (action.payload.isReset) {
        delete action.payload.isReset;
        return {
          ...state,
          appliedFilters: {
            ...initialState.appliedFilters,
            ...action.payload
          },
          pageNumber: initialState?.pageNumber
        };
      }
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...action.payload
        },
        pageNumber: initialState?.pageNumber
      };
    case OrdersConstants.GET_ORDERS_FACET_REQUEST:
      return {
        ...state,
        orderFacets: {
          loading: true,
          error: false
        }
      };
    case OrdersConstants.GET_ORDERS_FACET_SUCCESS:
      return {
        ...state,
        orderFacets: {
          loading: false,
          error: false,
          data: action.payload
        }
      };
    case OrdersConstants.GET_ORDERS_FACET_ERROR:
      return {
        ...state,
        orderFacets: {
          loading: false,
          error: true
        }
      };
      case OrdersConstants.GET_ORDERS_TABS_COUNT_REQUEST:
        return {
          ...state,
          orderTabsCount: {
            loading: true,
            error: false
          }
        };
      case OrdersConstants.GET_ORDERS_TABS_COUNT_SUCCESS:
        return {
          ...state,
          orderTabsCount: {
            loading: false,
            error: false,
            data: action.payload
          }
        };
      case OrdersConstants.GET_ORDERS_TABS_COUNT_ERROR:
        return {
          ...state,
          orderTabsCount: {
            loading: false,
            error: true
          }
        };
    case OrdersConstants.GET_ORDERS_SLA_FACET_REQUEST:
      return {
        ...state,
        orderSLAFacets: {
          loading: true,
          error: false
        }
      };
    case OrdersConstants.GET_ORDERS_SLA_FACET_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        orderSLAFacets: {
          loading: false,
          error: false,
          data: action.payload
        }
      };
    case OrdersConstants.orderSLAFacets:
      return {
        ...state,
        orderSLAFacets: {
          loading: false,
          error: true
        }
      };
    case OrdersConstants.APPLIED_STORE_FILTER:
      return {
        ...state,
        selectedStore: action.payload,
        pageNumber: initialState?.pageNumber
      };
    case OrdersConstants.ON_UPDATE_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
        pageNumber: initialState?.pageNumber
      };
    case OrdersConstants.UPDATE_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
        pageNumber: initialState?.pageNumber
      };
    case OrdersConstants.ON_CHANGE_PAGINATION:
      return {
        ...state,
        pageNumber: action.payload?.pageNumber || initialState?.pageNumber,
        pageSize: action.payload?.pageSize || initialState?.pageSize
      };
    default:
      return state;
  }
};

export default OrdersReducer;
